<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Multiselect from "@vueform/multiselect";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader, Multiselect
  },
  data() {

    return {
      title: "Vouchers",
      items: [
        {
          text: "Financeiro",
          href: "/"
        },
        {
          text: "Vouchers",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,

      empresaData: null,

      clienteData: null,
      showModalVoucher: false,
      voucherData: {},
      dtListPesqCli: null,
      loadingCliente: false,
      submittedVoucher: false,
      dtIniFiltro: null,
      dtFimFiltro: null,

    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted produto-list-endereco_0')
    this.atualizaDataList()
  },

  methods: {

    copiarChave(){
      console.log('copiarChave')

      navigator.clipboard.writeText(this.voucherData.chave);

      Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Chave copiada para área de transferência!",
        showConfirmButton: false,
        timer: 1500
      })

    },




    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))
      this.showModalPeriodo = false
      this.atualizaDataList()
    },


    confirmarVoucher() {
      console.log('confirmarVoucher')
      console.log(this.voucherData)
      this.submittedVoucher = true
      if (this.voucherData.pessoa_id && this.voucherData.validade && this.voucherData.valor) {
        console.log('voucherValidado')
        this.showModalVoucher = false
        api.post(`${getBaseUrl()}api/finanvoucher`, {
          'voucherData': this.voucherData
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.atualizaDataList()

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },


    pesqCliente(evt){
      console.log('pesqCliente')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query, c: 'CL' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCli = res.data
        });
      }
    },


    escolheuCli(){
      console.log('escolheuCli')
      this.loadingCliente = true
      console.log(this.voucherData.pessoa_id)
      this.loadingCliente = false

      // api.get(`${getBaseUrl()}api/clicod`, {
      //   params: { coddata: this.orctoData.cliente }
      // }).then((res) => {
      //   console.log('then axios')
      //   console.log(res.data)
      //   this.clienteData = res.data[0]
      //   this.ultPedsData = res.data[1]
      //
      //   let totalPed = 0
      //   this.ultPedsData.forEach((value) => {
      //     totalPed += value.valorliq
      //   });
      //
      //   this.somaPedidosCli = totalPed
      //   this.loadingCliente = false
      // })
    },


    carregouGrid(e){
      // console.log('carregouGrid')
      // this.totalList = e.component.totalCount()
      // this.title = `(${this.totalList}) Vouchers`
      console.log('carregouGrid')
      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
      this.title = `(${e.component.totalCount()}) Vouchers: ${dtIniFormated} - ${dtFimFormated}`
    },


    atualizaDataList(){
      console.log('atualizaDataList_vouchers')

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro


      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){
          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'di': di,
            'df': df

          }
          console.log('paramsReq')
          console.log(paramsReq)
          return api.get(`${getBaseUrl()}api/finanvouchers`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data_0')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })

    },



    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.atualizaDataList()
    },

    novoVoucher(){
      console.log('novoVoucher')
      this.submittedVoucher = false
      this.voucherData = {
        'validade': moment().add(30, 'days').format('YYYY-MM-DD'),
      }
      this.showModalVoucher = true

    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      // console.log(row)
      let idData = row.key
      console.log(idData)
      this.voucherData = row.data

      this.dtListPesqCli = [
        {
          'id': this.voucherData.pessoa_id,
          'nome': this.voucherData.pe_nome
        },
      ]

      this.showModalVoucher = true

    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          const valStatus = e.data.mov_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'AB':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'FE':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'CA':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'AB':
          return 'Aberto (AB)'
        case 'FE':
          return 'Fechado (FE)'
        case 'CA':
          return 'Cancelado (CA)'
      }
      return e.value
    },



    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    }

  },


};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"  @click="showModalWmsEndereco = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>


        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Novo Voucher"
              text="Novo Voucher"
              :on-click="novoVoucher"/>


        </DxItem>


      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strVoucherList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />


        <DxColumn sort-order="desc"
                  data-field="id"
                  caption="ID"
                  alignment="left"
                  data-type="number"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false">
        </DxColumn>

        <DxColumn
            data-field="status"
            caption="Status"
            alignment="center"
            data-type="text"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true" />


        <DxColumn data-field="pe_nome"
                  caption="Cliente"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>

        <DxColumn data-field="obs"
                  caption="Observação"
                  alignment="left"
                  data-type="text"
                  :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                  :allowHeaderFiltering="false"/>


        <DxColumn data-field="valor"
                  caption="Valor"
                  alignment="right"
                  data-type="number"
                  :format="formatDecimal"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false"/>


        <DxColumn data-field="saldo"
                  caption="Saldo"
                  alignment="right"
                  data-type="number"
                  :format="formatDecimal"
                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                  :allowHeaderFiltering="false"/>


        <DxColumn
            data-field="validade"
            caption="Validade"
            alignment="right"
            data-type="datetime"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>



        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>




    <b-modal size="lg"
             :title="voucherData.id > 0 ? `Detalhes Voucher (${ voucherData.id })` : 'Novo Voucher'"
             v-model="showModalVoucher"
             centered hide-footer>
      
      <div class="row mb-2">
        <div class="col-md-12">
          <div class="mb-3">
            <span>Selecionar Cliente</span>
            <multiselect id="inputCliente"
                         @search-change="pesqCliente"
                         @select="escolheuCli"
                         v-model="voucherData.pessoa_id"
                         placeholder="Pesquisar cliente"
                         :options="dtListPesqCli"
                         :searchable="true"
                         label="nome"
                         track-by="nome"
                         :disabled="voucherData.id > 0"
                         :style="submittedVoucher && !voucherData.pessoa_id ? 'border: 1px solid #f86c6b !important;' : ''"
                         value-prop="id">
              <template #option="slotProps">
                <div class="row">
                  <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                    <span class="mx-4" >
                    {{ slotProps.option.cnpj }}
                  </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                  <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
                </div>
              </template>
            </multiselect>
            <div v-if="submittedVoucher && !voucherData.pessoa_id">
              <span class="text-danger font-size-11">Campo Cliente obrigatório, favor preencher.</span>
            </div>
            
            
          </div>
        </div>
      </div>


      <div class="row mb-2">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="validade">Validade</label>
            <input
                id="validade"
                v-model="voucherData.validade"
                type="date"
                class="form-control"
                placeholder="Data de validade"
                :disabled="voucherData.id > 0"
                :class="{'is-invalid': submittedVoucher && !voucherData.validade}"/>
            <div v-if="submittedVoucher && !voucherData.validade"
                 class="invalid-feedback">
              <span>Campo validade obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="valor">Valor</label>
            <input
                id="valor"
                v-model="voucherData.valor"
                type="number"
                class="form-control"
                placeholder="Valor"
                :disabled="voucherData.id > 0"
                :class="{'is-invalid': submittedVoucher && !voucherData.valor}"/>
            <div v-if="submittedVoucher && !voucherData.valor"
                 class="invalid-feedback">
              <span>Campo valor obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        
      </div>

      <div class="row mb-2">


        <div class="col-md-6">
          <label for="chave">Chave</label>
          <div class="position-relative">
            <input
                id="chave"
                type="text"
                v-model="voucherData.chave"
                class="form-control"
                :disabled="true"
                placeholder="Chave (Automático)"/>

            <div class="chat-input-links" v-if="voucherData.chave">
              <ul class="list-inline mb-0">
                <li class="list-inline">
                  <a
                      @click="copiarChave"
                      href="javascript: void(0);"
                      v-b-tooltip.hover
                      placement="top"
                      title="Copiar Chave">
                    <i class="mdi mdi-content-copy"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>


      </div>

      <div class="row mb-2">

        <div class="col-lg-12">
          <div class="mb-3">
            <label for="obs">Observações</label>
            <div class="position-relative">
                  <textarea
                      id="obs"
                      v-model="voucherData.obs"
                      :disabled="voucherData.id > 0"
                      type="text"
                      rows="3"
                      class="form-control"
                      placeholder="Pbservações"/>
            </div>
          </div>
        </div>

      </div>

 

      <div v-if="!loadingCliente && clienteData">
        <router-link :to="`/cliente/detalhe/${clienteData.id}`" target="_blank" >
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ clienteData.codigo }} </span>
          </p>
        </router-link>
<!--        <p class="mb-2" v-if="orctoData.cliender === 1">-->
<!--          <span class="text-muted" > Entregar: </span>-->
<!--          <span> {{ clienteData.rua }}, {{ clienteData.numero }}, {{ clienteData.bairro }}  </span>-->
<!--          <span> | </span>-->
<!--          <span> {{ clienteData.cidade }} - {{ clienteData.estado }} </span>-->
<!--        </p>-->

<!--        <p class="mb-2" v-if="orctoData.cliender === 2">-->
<!--          <span class="text-muted" > Entregar: </span>-->
<!--          <span> {{ pessoaEnderData.rua1 }}, {{ pessoaEnderData.numero1 }}, {{ pessoaEnderData.bairro1 }}  </span>-->
<!--          <span> | </span>-->
<!--          <span> {{ pessoaEnderData.cidade1 }} - {{ pessoaEnderData.estado1 }} </span>-->
<!--        </p>-->

<!--        <p class="mb-2" v-if="orctoData.cliender === 3">-->
<!--          <span class="text-muted" > Entregar: </span>-->
<!--          <span> {{ pessoaEnderData.rua2 }}, {{ pessoaEnderData.numero2 }}, {{ pessoaEnderData.bairro2 }}  </span>-->
<!--          <span> | </span>-->
<!--          <span> {{ pessoaEnderData.cidade2 }} - {{ pessoaEnderData.estado2 }} </span>-->
<!--        </p>-->




      </div>


      <div>
        <div class="text-start mt-3">
          <router-link  to="/cliente/editar/0" target="_blank">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Cadastrar Novo Cliente
          </router-link>

        </div>
      </div>


      <div>
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalVoucher = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confirmarVoucher">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



  </Layout>
</template>